module.exports = __webpack_public_path__ + "img/flag-EC.c85f2a7e.png";